import React from "react";
import { callService, goTo } from "../../tools";
import {database} from '../../app-database';


export const savePhotoToBucket = (fotos, callback) => {

	return dispatch => {
		dispatch({ "type": "LOADER_SHOW" });
		Promise.all(fotos.map((f)=>{
			const {poliza, version, km, type, photo} = f;
			return new callService({
				service: 'pagoPorKilometro.guardarKM',
				secure: true,
				data: {
					poliza: poliza.replace(/^0+/, ''),
					version: version,
					kilometraje: km,
					tipo: type,
					foto: photo,
					polizaOriginal:poliza,
					isAutorizador: false
				},
				timeout:60000
			}).execute();
		}))
			.then(response => {
				dispatch({ type: "LOADER_HIDE" });
				let indexIni = fotos.findIndex((f)=> f.type =="ini");
				if(indexIni >=0 && !response[indexIni].success){
					if(response[indexIni].intento===3){
						// $('#modal-autorizador').modal('show');
						callback({res: false, modal:'modalAutorizador'});
					}
					else{
						var numPoliza=response[indexIni].poliza;
						database.ref("/kilometro/"+numPoliza+"/version/0/infDer" ).remove();
						database.ref("/kilometro/"+numPoliza+"/version/0/infIzq" ).remove();
						database.ref("/kilometro/"+numPoliza+"/version/0/supDer" ).remove();
						database.ref("/kilometro/"+numPoliza+"/version/0/supIzq" ).remove();
						database.ref("/kilometro/"+numPoliza+"/version/0/vin" ).remove();
						// $('#modal-error').modal('show');
						callback({res: false, modal: 'modalError'});	
					}
					
				}else{
					// $('#modal-registro').modal('show');
					callback({res: true, modal: 'modalRegistro'});
				}

			}).catch(error => {
				console.error(error);
				dispatch({ type: "LOADER_HIDE" });
				// $('#modal-error-2').modal('show');				
				callback({res: false, modal:'modalError2'});
			});
	};
};

export const savePhotoToBucketKmFinal = (foto, nombreContratante, callback) => {
	return dispatch => {
		dispatch({ "type": "LOADER_SHOW" });
			const {poliza, version, km, type, photo} = foto;
			new callService({
				service: 'pagoPorKilometro.guardarKM',
				secure: true,
				data: {
					poliza: poliza.replace(/^0+/, ''),
					version: version,
					kilometraje: km,
					tipo: type,
					foto: photo,
					polizaOriginal:poliza,
					nombreContratante
				},
				timeout:60000
			}).execute()
			.then(response => {
				dispatch({ type: "LOADER_HIDE" });
				if(!response.success){
					if(response.intento === 3)
						//$('#modal-autorizador').modal('show');
						callback({res: false, modal: 'modalAutorizador'});
					else{
						//$('#modal-error').modal('show');
						callback({res: false, modal: 'modalError'});
					}
				}else{
					if( response.winBenef ){
						//$('#modal-registro-cupon').modal('show');
						callback({res: true, modal: 'modalRegistroCupon'});
					}else{
						//$('#modal-registro-noCupon').modal('show');
						callback({res: true, modal: 'modalRegistroNoCupon'});
					}
				}
			}).catch(error => {
				console.error(error);
				dispatch({ type: "LOADER_HIDE" });
				//$('#modal-error-2').modal('show');
				callback({res: false, modal: 'modalError2'});
			});
	};
};

export const getClientInfo = (poliza, version) => {

	return new callService({
		service: 'pagoPorKilometro.consultar',
		secure: true,
		data: {
			poliza: poliza,
			version: version
		}
	}).execute();

}

export const getInfo = (poliza, version) => {

	return dispatch => {

		let service = new callService({
			service: 'pagoPorKilometro.consultar',
			secure: true,
			data: {
				poliza: poliza.replace(/^0+/, ''),
				version: version
			}
		}).execute()
		.then(response => {

			dispatch({
				type: 'SET_PXK',
				pagoPorKilometro: response
			});
		}).catch(error => {

			// dispatch({ type: "LOADER_HIDE" });
			// dispatch({
			// 	type: "MODAL_ALERT_MESSAGES_SHOW",
			// 	titulo: "Error al realizar el registro",
			// 	mensaje: "El servicio se encuentra temporalmente fuera de servicio, favor de intentar más tarde."
			// });
			console.log(error);

		});		

	}

}

export const getPolizaInfo = () => {

	return new callService({
		service: 'pagoPorKilometro.consultarAutorizador',
		secure: true,
		data: {}
	}).execute();

}

export const updateStatusKm= (poliza) => {

	return new callService({
		service: 'pagoPorKilometro.actualizarEstatusKm',
		secure: true,
		data: {
			poliza:poliza.poliza,
			img:poliza.img,
			mail:poliza.mail,
			ban_descuento:poliza.ban_descuento,
			subject:poliza.subject,
			km:poliza.km
		}
	}).execute();

}

export const updateStatusNuevo= (poliza) => {
	console.log("fecha hoy: "+poliza.fechaReintento);
	return new callService({
		service: 'pagoPorKilometro.actualizarNuevoKm',
		secure: true,
		data: {
			poliza:poliza.poliza,
			img:poliza.img,
			mail:poliza.mail,
			numIntento:poliza.numIntento,
			subject:poliza.subject,
			fechaReintento:poliza.fechaReintento
		}
	}).execute();

}

export const getCorreoCU = (clienteUnico) => {

	return new callService({
		service: 'pagoPorKilometro.consultarCorreo',
		secure: true,
		data: {
			clienteUnico: clienteUnico
		}
	}).execute();

}


// WEBPACK FOOTER //
// ./src/movil/polizas/pagoPorKilometro.act.js